import type * as Types from '../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DiagnosticTemplateListFieldsFragment = { __typename?: 'DiagnosticTemplate', id: string, name: string };

export type DiagnosticSubjectLicenseFieldsFragment = { __typename?: 'Guide', subject?: { __typename?: 'Subject', id: string, name: string, hasAccessViaLicenseAsTeacher?: boolean | null } | null };

export type TranslationAvailabilityFieldsFragment = { __typename?: 'Guide', id: string, subject?: { __typename?: 'Subject', id: string, translateQuestions: boolean } | null };

export type DiagnosticTemplateFieldsFragment = { __typename?: 'DiagnosticTemplate', id: string, name: string, guideId: string, defaultTimeLimit?: number | null, guide: { __typename?: 'Guide', id: string, subject?: { __typename?: 'Subject', id: string, translateQuestions: boolean, name: string, hasAccessViaLicenseAsTeacher?: boolean | null } | null }, skills: Array<{ __typename?: 'GuideLevel', id: string, name: string }> };

export type DiagnosticTemplateListQueryVariables = Types.Exact<{
  filter: Types.DiagnosticTemplateFilterInput;
}>;


export type DiagnosticTemplateListQuery = { __typename?: 'RootQueryType', diagnosticTemplates?: { __typename?: 'KeysetPageOfDiagnosticTemplate', results?: Array<{ __typename?: 'DiagnosticTemplate', id: string, name: string }> | null } | null };

export type DiagnosticTemplateForAssignmentQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DiagnosticTemplateForAssignmentQuery = { __typename?: 'RootQueryType', diagnosticTemplate?: { __typename?: 'DiagnosticTemplate', id: string, name: string, guideId: string, defaultTimeLimit?: number | null, guide: { __typename?: 'Guide', id: string, subject?: { __typename?: 'Subject', id: string, translateQuestions: boolean, name: string, hasAccessViaLicenseAsTeacher?: boolean | null } | null }, skills: Array<{ __typename?: 'GuideLevel', id: string, name: string }> } | null };

export type DiagnosticSettingsFieldsFragment = { __typename?: 'DiagnosticSettings', id: string, startDate?: any | null, dueDate: any, endDate?: any | null, translationAccess: boolean, timeLimit?: number | null, studentDiagnostics: Array<{ __typename?: 'StudentDiagnostic', id: string, studentId: string, enrolledViaClassroomId: string, archived?: boolean | null }>, classroomDiagnosticConfigs: Array<{ __typename?: 'ClassroomDiagnosticConfig', id: string, classroomId: string, archived?: boolean | null }> };

export type DiagnosticFieldsFragment = { __typename?: 'Diagnostic', id: string, name: string, guideId: string, diagnosticTemplateId?: string | null, externallyAssignedStudentIds: Array<string>, guide: { __typename?: 'Guide', id: string, subject?: { __typename?: 'Subject', id: string, translateQuestions: boolean, name: string, hasAccessViaLicenseAsTeacher?: boolean | null } | null }, skills: Array<{ __typename?: 'GuideLevel', id: string, name: string, code?: string | null }>, diagnosticSettings: Array<{ __typename?: 'DiagnosticSettings', id: string, startDate?: any | null, dueDate: any, endDate?: any | null, translationAccess: boolean, timeLimit?: number | null, studentDiagnostics: Array<{ __typename?: 'StudentDiagnostic', id: string, studentId: string, enrolledViaClassroomId: string, archived?: boolean | null }>, classroomDiagnosticConfigs: Array<{ __typename?: 'ClassroomDiagnosticConfig', id: string, classroomId: string, archived?: boolean | null }> }> };

export type DiagnosticQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DiagnosticQuery = { __typename?: 'RootQueryType', diagnostic?: { __typename?: 'Diagnostic', id: string, name: string, guideId: string, diagnosticTemplateId?: string | null, externallyAssignedStudentIds: Array<string>, guide: { __typename?: 'Guide', id: string, subject?: { __typename?: 'Subject', id: string, translateQuestions: boolean, name: string, hasAccessViaLicenseAsTeacher?: boolean | null } | null }, skills: Array<{ __typename?: 'GuideLevel', id: string, name: string, code?: string | null }>, diagnosticSettings: Array<{ __typename?: 'DiagnosticSettings', id: string, startDate?: any | null, dueDate: any, endDate?: any | null, translationAccess: boolean, timeLimit?: number | null, studentDiagnostics: Array<{ __typename?: 'StudentDiagnostic', id: string, studentId: string, enrolledViaClassroomId: string, archived?: boolean | null }>, classroomDiagnosticConfigs: Array<{ __typename?: 'ClassroomDiagnosticConfig', id: string, classroomId: string, archived?: boolean | null }> }> } | null };

export type CreateDiagnosticMutationVariables = Types.Exact<{
  input: Types.CreateDiagnosticInput;
}>;


export type CreateDiagnosticMutation = { __typename?: 'RootMutationType', createDiagnostic: { __typename?: 'CreateDiagnosticResult', result?: { __typename?: 'Diagnostic', id: string, name: string, guideId: string, diagnosticTemplateId?: string | null, externallyAssignedStudentIds: Array<string>, guide: { __typename?: 'Guide', id: string, subject?: { __typename?: 'Subject', id: string, translateQuestions: boolean, name: string, hasAccessViaLicenseAsTeacher?: boolean | null } | null }, skills: Array<{ __typename?: 'GuideLevel', id: string, name: string, code?: string | null }>, diagnosticSettings: Array<{ __typename?: 'DiagnosticSettings', id: string, startDate?: any | null, dueDate: any, endDate?: any | null, translationAccess: boolean, timeLimit?: number | null, studentDiagnostics: Array<{ __typename?: 'StudentDiagnostic', id: string, studentId: string, enrolledViaClassroomId: string, archived?: boolean | null }>, classroomDiagnosticConfigs: Array<{ __typename?: 'ClassroomDiagnosticConfig', id: string, classroomId: string, archived?: boolean | null }> }> } | null, errors: Array<{ __typename?: 'MutationError', message?: string | null }> } };

export type UpdateDiagnosticMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  input: Types.UpdateDiagnosticInput;
}>;


export type UpdateDiagnosticMutation = { __typename?: 'RootMutationType', updateDiagnostic: { __typename?: 'UpdateDiagnosticResult', result?: { __typename?: 'Diagnostic', id: string, name: string, guideId: string, diagnosticTemplateId?: string | null, externallyAssignedStudentIds: Array<string>, guide: { __typename?: 'Guide', id: string, subject?: { __typename?: 'Subject', id: string, translateQuestions: boolean, name: string, hasAccessViaLicenseAsTeacher?: boolean | null } | null }, skills: Array<{ __typename?: 'GuideLevel', id: string, name: string, code?: string | null }>, diagnosticSettings: Array<{ __typename?: 'DiagnosticSettings', id: string, startDate?: any | null, dueDate: any, endDate?: any | null, translationAccess: boolean, timeLimit?: number | null, studentDiagnostics: Array<{ __typename?: 'StudentDiagnostic', id: string, studentId: string, enrolledViaClassroomId: string, archived?: boolean | null }>, classroomDiagnosticConfigs: Array<{ __typename?: 'ClassroomDiagnosticConfig', id: string, classroomId: string, archived?: boolean | null }> }> } | null, errors: Array<{ __typename?: 'MutationError', message?: string | null }> } };

export type DeleteDiagnosticMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteDiagnosticMutation = { __typename?: 'RootMutationType', deleteDiagnostic: { __typename?: 'DeleteDiagnosticResult', result?: { __typename?: 'Diagnostic', id: string } | null, errors: Array<{ __typename?: 'MutationError', message?: string | null }> } };

export const DiagnosticTemplateListFieldsFragmentDoc = gql`
    fragment DiagnosticTemplateListFields on DiagnosticTemplate {
  id
  name
}
    `;
export const TranslationAvailabilityFieldsFragmentDoc = gql`
    fragment TranslationAvailabilityFields on Guide {
  id
  subject {
    id
    translateQuestions
  }
}
    `;
export const DiagnosticSubjectLicenseFieldsFragmentDoc = gql`
    fragment DiagnosticSubjectLicenseFields on Guide {
  subject {
    id
    name
    hasAccessViaLicenseAsTeacher
  }
}
    `;
export const DiagnosticTemplateFieldsFragmentDoc = gql`
    fragment DiagnosticTemplateFields on DiagnosticTemplate {
  id
  name
  guideId
  defaultTimeLimit
  guide {
    ...TranslationAvailabilityFields
    ...DiagnosticSubjectLicenseFields
  }
  skills {
    id
    name
  }
}
    ${TranslationAvailabilityFieldsFragmentDoc}
${DiagnosticSubjectLicenseFieldsFragmentDoc}`;
export const DiagnosticSettingsFieldsFragmentDoc = gql`
    fragment DiagnosticSettingsFields on DiagnosticSettings {
  id
  startDate
  dueDate
  endDate
  translationAccess
  timeLimit
  studentDiagnostics {
    id
    studentId
    enrolledViaClassroomId
    archived
  }
  classroomDiagnosticConfigs {
    id
    classroomId
    archived
  }
}
    `;
export const DiagnosticFieldsFragmentDoc = gql`
    fragment DiagnosticFields on Diagnostic {
  id
  name
  guideId
  guide {
    ...TranslationAvailabilityFields
    ...DiagnosticSubjectLicenseFields
  }
  diagnosticTemplateId
  externallyAssignedStudentIds
  skills {
    id
    name
    code
  }
  diagnosticSettings {
    ...DiagnosticSettingsFields
  }
}
    ${TranslationAvailabilityFieldsFragmentDoc}
${DiagnosticSubjectLicenseFieldsFragmentDoc}
${DiagnosticSettingsFieldsFragmentDoc}`;
export const DiagnosticTemplateListDocument = gql`
    query DiagnosticTemplateList($filter: DiagnosticTemplateFilterInput!) {
  diagnosticTemplates(filter: $filter, sort: [{field: NAME, order: ASC}]) {
    results {
      ...DiagnosticTemplateListFields
    }
  }
}
    ${DiagnosticTemplateListFieldsFragmentDoc}`;

/**
 * __useDiagnosticTemplateListQuery__
 *
 * To run a query within a React component, call `useDiagnosticTemplateListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiagnosticTemplateListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiagnosticTemplateListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDiagnosticTemplateListQuery(baseOptions: Apollo.QueryHookOptions<DiagnosticTemplateListQuery, DiagnosticTemplateListQueryVariables> & ({ variables: DiagnosticTemplateListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiagnosticTemplateListQuery, DiagnosticTemplateListQueryVariables>(DiagnosticTemplateListDocument, options);
      }
export function useDiagnosticTemplateListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiagnosticTemplateListQuery, DiagnosticTemplateListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiagnosticTemplateListQuery, DiagnosticTemplateListQueryVariables>(DiagnosticTemplateListDocument, options);
        }
// @ts-ignore
export function useDiagnosticTemplateListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DiagnosticTemplateListQuery, DiagnosticTemplateListQueryVariables>): Apollo.UseSuspenseQueryResult<DiagnosticTemplateListQuery, DiagnosticTemplateListQueryVariables>;
export function useDiagnosticTemplateListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiagnosticTemplateListQuery, DiagnosticTemplateListQueryVariables>): Apollo.UseSuspenseQueryResult<DiagnosticTemplateListQuery | undefined, DiagnosticTemplateListQueryVariables>;
export function useDiagnosticTemplateListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiagnosticTemplateListQuery, DiagnosticTemplateListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiagnosticTemplateListQuery, DiagnosticTemplateListQueryVariables>(DiagnosticTemplateListDocument, options);
        }
export type DiagnosticTemplateListQueryHookResult = ReturnType<typeof useDiagnosticTemplateListQuery>;
export type DiagnosticTemplateListLazyQueryHookResult = ReturnType<typeof useDiagnosticTemplateListLazyQuery>;
export type DiagnosticTemplateListSuspenseQueryHookResult = ReturnType<typeof useDiagnosticTemplateListSuspenseQuery>;
export type DiagnosticTemplateListQueryResult = Apollo.QueryResult<DiagnosticTemplateListQuery, DiagnosticTemplateListQueryVariables>;
export const DiagnosticTemplateForAssignmentDocument = gql`
    query DiagnosticTemplateForAssignment($id: ID!) {
  diagnosticTemplate(id: $id) {
    ...DiagnosticTemplateFields
  }
}
    ${DiagnosticTemplateFieldsFragmentDoc}`;

/**
 * __useDiagnosticTemplateForAssignmentQuery__
 *
 * To run a query within a React component, call `useDiagnosticTemplateForAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiagnosticTemplateForAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiagnosticTemplateForAssignmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDiagnosticTemplateForAssignmentQuery(baseOptions: Apollo.QueryHookOptions<DiagnosticTemplateForAssignmentQuery, DiagnosticTemplateForAssignmentQueryVariables> & ({ variables: DiagnosticTemplateForAssignmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiagnosticTemplateForAssignmentQuery, DiagnosticTemplateForAssignmentQueryVariables>(DiagnosticTemplateForAssignmentDocument, options);
      }
export function useDiagnosticTemplateForAssignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiagnosticTemplateForAssignmentQuery, DiagnosticTemplateForAssignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiagnosticTemplateForAssignmentQuery, DiagnosticTemplateForAssignmentQueryVariables>(DiagnosticTemplateForAssignmentDocument, options);
        }
// @ts-ignore
export function useDiagnosticTemplateForAssignmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DiagnosticTemplateForAssignmentQuery, DiagnosticTemplateForAssignmentQueryVariables>): Apollo.UseSuspenseQueryResult<DiagnosticTemplateForAssignmentQuery, DiagnosticTemplateForAssignmentQueryVariables>;
export function useDiagnosticTemplateForAssignmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiagnosticTemplateForAssignmentQuery, DiagnosticTemplateForAssignmentQueryVariables>): Apollo.UseSuspenseQueryResult<DiagnosticTemplateForAssignmentQuery | undefined, DiagnosticTemplateForAssignmentQueryVariables>;
export function useDiagnosticTemplateForAssignmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiagnosticTemplateForAssignmentQuery, DiagnosticTemplateForAssignmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiagnosticTemplateForAssignmentQuery, DiagnosticTemplateForAssignmentQueryVariables>(DiagnosticTemplateForAssignmentDocument, options);
        }
export type DiagnosticTemplateForAssignmentQueryHookResult = ReturnType<typeof useDiagnosticTemplateForAssignmentQuery>;
export type DiagnosticTemplateForAssignmentLazyQueryHookResult = ReturnType<typeof useDiagnosticTemplateForAssignmentLazyQuery>;
export type DiagnosticTemplateForAssignmentSuspenseQueryHookResult = ReturnType<typeof useDiagnosticTemplateForAssignmentSuspenseQuery>;
export type DiagnosticTemplateForAssignmentQueryResult = Apollo.QueryResult<DiagnosticTemplateForAssignmentQuery, DiagnosticTemplateForAssignmentQueryVariables>;
export const DiagnosticDocument = gql`
    query Diagnostic($id: ID!) {
  diagnostic(id: $id) {
    ...DiagnosticFields
  }
}
    ${DiagnosticFieldsFragmentDoc}`;

/**
 * __useDiagnosticQuery__
 *
 * To run a query within a React component, call `useDiagnosticQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiagnosticQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiagnosticQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDiagnosticQuery(baseOptions: Apollo.QueryHookOptions<DiagnosticQuery, DiagnosticQueryVariables> & ({ variables: DiagnosticQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiagnosticQuery, DiagnosticQueryVariables>(DiagnosticDocument, options);
      }
export function useDiagnosticLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiagnosticQuery, DiagnosticQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiagnosticQuery, DiagnosticQueryVariables>(DiagnosticDocument, options);
        }
// @ts-ignore
export function useDiagnosticSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DiagnosticQuery, DiagnosticQueryVariables>): Apollo.UseSuspenseQueryResult<DiagnosticQuery, DiagnosticQueryVariables>;
export function useDiagnosticSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiagnosticQuery, DiagnosticQueryVariables>): Apollo.UseSuspenseQueryResult<DiagnosticQuery | undefined, DiagnosticQueryVariables>;
export function useDiagnosticSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiagnosticQuery, DiagnosticQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiagnosticQuery, DiagnosticQueryVariables>(DiagnosticDocument, options);
        }
export type DiagnosticQueryHookResult = ReturnType<typeof useDiagnosticQuery>;
export type DiagnosticLazyQueryHookResult = ReturnType<typeof useDiagnosticLazyQuery>;
export type DiagnosticSuspenseQueryHookResult = ReturnType<typeof useDiagnosticSuspenseQuery>;
export type DiagnosticQueryResult = Apollo.QueryResult<DiagnosticQuery, DiagnosticQueryVariables>;
export const CreateDiagnosticDocument = gql`
    mutation CreateDiagnostic($input: CreateDiagnosticInput!) {
  createDiagnostic(input: $input) {
    result {
      ...DiagnosticFields
    }
    errors {
      message
    }
  }
}
    ${DiagnosticFieldsFragmentDoc}`;
export type CreateDiagnosticMutationFn = Apollo.MutationFunction<CreateDiagnosticMutation, CreateDiagnosticMutationVariables>;

/**
 * __useCreateDiagnosticMutation__
 *
 * To run a mutation, you first call `useCreateDiagnosticMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiagnosticMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiagnosticMutation, { data, loading, error }] = useCreateDiagnosticMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDiagnosticMutation(baseOptions?: Apollo.MutationHookOptions<CreateDiagnosticMutation, CreateDiagnosticMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDiagnosticMutation, CreateDiagnosticMutationVariables>(CreateDiagnosticDocument, options);
      }
export type CreateDiagnosticMutationHookResult = ReturnType<typeof useCreateDiagnosticMutation>;
export type CreateDiagnosticMutationResult = Apollo.MutationResult<CreateDiagnosticMutation>;
export type CreateDiagnosticMutationOptions = Apollo.BaseMutationOptions<CreateDiagnosticMutation, CreateDiagnosticMutationVariables>;
export const UpdateDiagnosticDocument = gql`
    mutation UpdateDiagnostic($id: ID!, $input: UpdateDiagnosticInput!) {
  updateDiagnostic(id: $id, input: $input) {
    result {
      ...DiagnosticFields
    }
    errors {
      message
    }
  }
}
    ${DiagnosticFieldsFragmentDoc}`;
export type UpdateDiagnosticMutationFn = Apollo.MutationFunction<UpdateDiagnosticMutation, UpdateDiagnosticMutationVariables>;

/**
 * __useUpdateDiagnosticMutation__
 *
 * To run a mutation, you first call `useUpdateDiagnosticMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiagnosticMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiagnosticMutation, { data, loading, error }] = useUpdateDiagnosticMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDiagnosticMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDiagnosticMutation, UpdateDiagnosticMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDiagnosticMutation, UpdateDiagnosticMutationVariables>(UpdateDiagnosticDocument, options);
      }
export type UpdateDiagnosticMutationHookResult = ReturnType<typeof useUpdateDiagnosticMutation>;
export type UpdateDiagnosticMutationResult = Apollo.MutationResult<UpdateDiagnosticMutation>;
export type UpdateDiagnosticMutationOptions = Apollo.BaseMutationOptions<UpdateDiagnosticMutation, UpdateDiagnosticMutationVariables>;
export const DeleteDiagnosticDocument = gql`
    mutation DeleteDiagnostic($id: ID!) {
  deleteDiagnostic(id: $id) {
    result {
      id
    }
    errors {
      message
    }
  }
}
    `;
export type DeleteDiagnosticMutationFn = Apollo.MutationFunction<DeleteDiagnosticMutation, DeleteDiagnosticMutationVariables>;

/**
 * __useDeleteDiagnosticMutation__
 *
 * To run a mutation, you first call `useDeleteDiagnosticMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiagnosticMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDiagnosticMutation, { data, loading, error }] = useDeleteDiagnosticMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDiagnosticMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDiagnosticMutation, DeleteDiagnosticMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDiagnosticMutation, DeleteDiagnosticMutationVariables>(DeleteDiagnosticDocument, options);
      }
export type DeleteDiagnosticMutationHookResult = ReturnType<typeof useDeleteDiagnosticMutation>;
export type DeleteDiagnosticMutationResult = Apollo.MutationResult<DeleteDiagnosticMutation>;
export type DeleteDiagnosticMutationOptions = Apollo.BaseMutationOptions<DeleteDiagnosticMutation, DeleteDiagnosticMutationVariables>;